import { render, staticRenderFns } from "./jygm-two-diagram.vue?vue&type=template&id=057bf581&scoped=true&"
import script from "./jygm-two-diagram.vue?vue&type=script&lang=js&"
export * from "./jygm-two-diagram.vue?vue&type=script&lang=js&"
import style0 from "./jygm-two-diagram.vue?vue&type=style&index=0&id=057bf581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bf581",
  null
  
)

export default component.exports